import { NavLink } from 'react-router-dom';
import { Home, Search, Moon, User } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';

interface Props {
  onOpenPalette?: () => void;
}

export function BottomTabBar({ onOpenPalette }: Props) {
  const { t } = useI18n();

  return (
    <nav
      className="bottom-nav"
      aria-label={t('tabs.ariaLabel')}
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <NavLink
        to="/dashboard"
        end
        className={({ isActive }) => `bottom-nav-item${isActive ? ' active' : ''}`}
        aria-label={t('tabs.home')}
      >
        <Home size={22} aria-hidden />
        <span style={{ fontSize: 'var(--text-caption)' }}>{t('tabs.home')}</span>
      </NavLink>

      <button
        className="bottom-nav-item"
        onClick={onOpenPalette}
        aria-label={t('tabs.search')}
        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
      >
        <Search size={22} aria-hidden />
        <span style={{ fontSize: 'var(--text-caption)' }}>{t('tabs.search')}</span>
      </button>

      <NavLink
        to="/forecast"
        className={({ isActive }) => `bottom-nav-item${isActive ? ' active' : ''}`}
        aria-label={t('tabs.today')}
      >
        <Moon size={22} aria-hidden />
        <span style={{ fontSize: 'var(--text-caption)' }}>{t('tabs.today')}</span>
      </NavLink>

      <NavLink
        to="/profile"
        className={({ isActive }) => `bottom-nav-item${isActive ? ' active' : ''}`}
        aria-label={t('tabs.me')}
      >
        <User size={22} aria-hidden />
        <span style={{ fontSize: 'var(--text-caption)' }}>{t('tabs.me')}</span>
      </NavLink>
    </nav>
  );
}
